/* eslint-disable spire/export-styles */
import translate from "@insite/client-framework/Translate";
import Icon, { IconProps } from "@insite/mobius/Icon";
import Link, { LinkPresentationProps, LinkProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import * as React from "react";
import { css } from "styled-components";

type Props = LinkProps & {
    address1: string;
    address2?: string;
    city: string;
    state: string;
    postalCode: string;
};

export interface ProductCarouselProductStyles {
    locationGoogleMapsDirectionLink?: LinkPresentationProps;
    iconStyles?: IconProps;
}

export const productCarouselProductStyles: ProductCarouselProductStyles = {
    locationGoogleMapsDirectionLink: {
        color: "secondary",
        css: css`
            display: block;
            span {
                display: flex;
                align-items: center;
            }
        `,
    },
    iconStyles: {
        size: 16,
        src: "ChevronRight",
        color: `${getColor("common.ui1")}`,
        css: css`
            margin-left: 6px;
        `,
    },
};
const styles = productCarouselProductStyles;

const GoogleMapsDirectionLink: React.FC<Props> = ({
    address1,
    address2,
    city,
    state,
    postalCode,
    target = "_blank",
    ...otherProps
}) => {
    const linkAddress = `http://maps.google.com/maps?daddr=${address1} ${address2}, ${city}, ${state} ${postalCode}`;
    return (
        <Link href={linkAddress} target={target} {...styles.locationGoogleMapsDirectionLink} {...otherProps}>
            <Typography>{translate("Directions")}</Typography>
            <Icon {...styles.iconStyles} />
        </Link>
    );
};

export default GoogleMapsDirectionLink;
